import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Legacy login route - redirects to new route
 * @deprecated Use /auth/login instead
 */
const LoginPage: React.FC = () => {
    const router = useRouter();

    useEffect(() => {
        const queryString = router.asPath.split('?')[1];
        const newPath = queryString ? `/auth/login?${queryString}` : '/auth/login';
        router.replace(newPath);
    }, [router]);

    return <div>Yuklanmoqda...</div>;
};

export default LoginPage;
